import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TemplateRequest } from '../models/template/template-request.interface';
import { GetTemplateRequest } from '../models/template/get-template-request.interface';

@Injectable({
  providedIn: 'root',
})
export class TranslateService {
  private isTranslatorSubject = new BehaviorSubject<boolean>(false);
  isTranslator$ = this.isTranslatorSubject.asObservable();

  public setIsTranslator(isTranslator: boolean) {
    this.isTranslatorSubject.next(isTranslator);
  }

  private getHostUrl = () => {
    const url = environment.scheme + environment.host + environment.port + '/';
    return url;
  };

  private readonly templateUrl = `${this.getHostUrl()}api/v${environment.version
    }/translate/template`;

  private readonly templatesUrl = `${this.getHostUrl()}api/v${environment.version
    }/translate/templates`;

  private readonly approveTranslationsUrl = `${this.getHostUrl()}api/v${environment.version
    }/translate/approveTranslations`;

  private readonly templateStatusUrl = `${this.getHostUrl()}api/v${environment.version
    }/translate/translateTemplateStatus`;

  private readonly approvedTemplateUrl = `${this.getHostUrl()}api/v${environment.version
    }/translate/approvedTemplate`;

  constructor(private http: HttpClient) {
  }

  createInitialTemplates(templateRequest: TemplateRequest): Observable<any> {
    return this.http.post<any>(this.templatesUrl, templateRequest);
  }

  getTemplate(getTemplateRequest: GetTemplateRequest): Observable<any> {
    const params = new HttpParams()
      .set('templateName', getTemplateRequest.templateName)
      .set('templateType', getTemplateRequest.templateType)
      .set('language', getTemplateRequest.language);
    return this.http.get<any>(this.templateUrl, { params });
  }

  getTemplateStatus(templateName: string, language: string): Observable<any> {
    const params = new HttpParams()
      .set('templateName', templateName)
      .set('language', language);
    return this.http.get<any>(this.templateStatusUrl, { params });
  }

  getTemplatesByTemplateName(templateName: string): Observable<any> {
    const params = new HttpParams().set('templateName', templateName);
    return this.http.get<any>(this.templatesUrl, { params });
  }

  checkIfApprovedTemplate(templateName: string): Observable<any> {
    const params = new HttpParams().set('templateName', templateName);
    return this.http.get<any>(this.approvedTemplateUrl, { params });
  }

  updateTemplate(templateRequest: TemplateRequest): Observable<any> {
    return this.http.put<any>(this.templateUrl, templateRequest);
  }

  approveTranslations(templateName: string): Observable<any> {
    const formData = new FormData();

    formData.append('templateName', templateName);

    return this.http.post<any>(this.approveTranslationsUrl, formData);
  }

  updateTemplateStatus(
    templateId: string,
    templateStatus: boolean
  ): Observable<any> {
    const formData = new FormData();

    formData.append('templateId', templateId);
    formData.append('templateStatus', templateStatus.toString());

    return this.http.put<any>(this.templateStatusUrl, formData);
  }

  public setTranslatorParams(isTranslator: boolean, params = new HttpParams()) {
    if (isTranslator) {
      params = params.set('translationTemplate', true);
    }
    return params;
  }
}
